const JS_COMPUTED_VALID_CSS_PROPERTIES = [
  'font-size',
  'font-family',
  'font-size-adjust',
  'font-stretch',
  'font-style',
  'font-weight',
  // 'text-shadow',
  'line-height',
  'letter-spacing',
  'word-spacing',
  'text-transform',
  'text-indent',
  // 'vertical-align',
  // 'word-break',
  // 'white-space',
  // 'word-wrap',
  // 'writing-mode',
  'font-feature-settings',
  'font-kerning',
  'font-language-override',
  'font-optical-sizing',
  // 'font-smooth',
  'font-synthesis',
  'font-variant',
  'font-variant-alternates',
  'font-variant-caps',
  'font-variant-east-asian',
  'font-variant-emoji',
  'font-variant-ligatures',
  'font-variant-numeric',
  'font-variant-position',
  'font-variation-settings',
  'text-combine-upright',
  'text-emphasis',
  'text-emphasis-position',
  'text-emphasis-style',
  'text-orientation',
  'text-rendering',
  'text-size-adjust',
  // 'line-break',
  'line-height-step',
  'initial-letter',
  'inline-size',
];

const JS_COMPUTED_NUMBER_TO_PX_PROPERTIES = [
  'font-size',
  'letter-spacing',
  'word-spacing',
  'text-indent',
  'line-height-step',
  'inline-size',
];

export {
  JS_COMPUTED_VALID_CSS_PROPERTIES,
  JS_COMPUTED_NUMBER_TO_PX_PROPERTIES,
};
